import {useState, useRef, useEffect} from 'react'; 
import Tooltip from '@/components/tooltip.js'; 
export default function Clipboard(props) {
  const { pageUrl} =   props
  const [toolTip, setTooltip] = useState(false); 
  const clipboardInput = useRef(); 
  const copy = () => {
    let copyText = clipboardInput.current;
    copyText.select();
    copyText.setSelectionRange(0, 99999);
    navigator.clipboard.writeText(copyText.value);
  }
  const showTooltip = () => {
    window.addEventListener('animationend', hideTooltip)
    setTooltip(true);
  }
  const hideTooltip = () => {
    setTooltip(false);
  }
  useEffect(() => {
    return window.removeEventListener('animationend', hideTooltip )
  } , [toolTip])
  return (
    <>
      {pageUrl &&
      <input type="text" readOnly={true}  value={pageUrl} className="lexcms-product-comparison-page-share-results-url" ref={clipboardInput} ></input>
      }
      <div className ="lexcms-alert-popover-wrapper">
        <button className="lexcms-regular-button lexcms-share-button" 
          onClick={()=> { copy(); showTooltip();}}  >
          <div className="lexcms-share-button-icon"></div>Copy URL to Clipboard
        </button>
        <Tooltip toolTip={toolTip} >
          <p>The URL has been copied to your clipboard.</p>
        </Tooltip>
      </div>
    </>
  )
}
